import { Pipe, PipeTransform, inject } from '@angular/core';
import { Guid, isNil, Nillable } from '@web/utils';
import { Observable, of } from 'rxjs';
import { WarehouseMultimediaDataSourceService } from '../services/warehouse-multimedia-data-source.service';
import { AdminMultimediaDetails } from '@web/shared/module/multimedia';

@Pipe({
  name: 'fetchWarehouseMultimediaById',
  standalone: true,
})
export class FetchWarehouseMultimediaByIdPipe implements PipeTransform {
  /* prettier-ignore */
  private readonly warehouseMultimediaDataSource = inject(WarehouseMultimediaDataSourceService);

  public transform(
    id: Nillable<Guid>,
    cacheable = false,
  ): Observable<Nillable<AdminMultimediaDetails>> {
    if (isNil(id)) {
      return of(null);
    }

    return this.warehouseMultimediaDataSource.fetchDetailsById(id, cacheable);
  }
}
